import styled from 'styled-components';

export const OuterWrap = styled.div.attrs(() => ({
  className: 'outer-wrap',
}))`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;
